





















































































import Vue from "vue";
import VueSortable from "../../../components/sortable";

const fieldName = {
    id: "ID",
    comment: "Комментарий",
    contacts: "Контакт",
    date: "Дата",
    items: "Товары в корзине",
    region: "Регион",
    status: "Статус",
    time: "Время для звонка",
    topic: "Тема",
    url: "Страница заявки",
}

const statusName = ['Новые', 'Выполненные', 'В работе', 'Не отвечает', 'Перезвонить']

export default Vue.extend({
    props: {
        settings: {
            type: Object
        },
        status: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            modal: $(),
            statusName: statusName,
            fieldName: fieldName,
            newSettings: {
                backend_fields: {},
                backend_status: {},
                backend_fields_sorted: []
            },
        }
    },
    mounted() {
        this.modal = $('#settingsModal')
        if (this.status) {
            this.modal.modal('show')
        }

        this.newSettings = this.clone(this.settings)
        this.newSettings.backend_fields = this.clone(this.settings.backend_fields)
        this.newSettings.backend_status = this.clone(this.settings.backend_status)
    },
    methods: {
        hide() {
            this.modal.modal('hide')
        },
        show() {
            this.modal.modal('show')
        },
        save() {
            this.$emit('save', this.newSettings)
            this.hide()
        },
        clone(obj: any) {
            if (null == obj || "object" != typeof obj) return obj
            var copy = obj.constructor()
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
            }
            return copy
        },
        getSortParams() {
            let params = {
                animation: 150,
                handle: '.sort-handle',
                onEnd: this.sortUpdate
            }
            return params 
        },
        sortUpdate(event: any) {
            let clonedItems = this.newSettings.backend_fields_sorted.filter((item: any) => {
                return item;
            });
            clonedItems.splice(event.newIndex, 0, clonedItems.splice(event.oldIndex, 1)[0]);
            this.newSettings.backend_fields_sorted = [];
            this.$nextTick(() => {
                this.newSettings.backend_fields_sorted = clonedItems;
            });
        }
    },
    directives: {
        sortable: VueSortable
    }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/backend/components/dialogs/SettingsModal.vue